import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { INews } from '../../services/announcement/models/news.interface';
import { UtilityService } from '../../services/utility/utility.service';
import * as _ from 'lodash';

@Component({
  selector: 'upsc-news-list',
  templateUrl: './news-list.component.html',
  styleUrls: ['./news-list.component.scss'],
})
export class NewsListComponent implements OnInit, OnChanges {
  @Input() items: INews[];

  public displayedItems: INews[];

  constructor(private utilityService: UtilityService) {
  }

  public ngOnInit() {
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.onItemsChanged(changes['items']);
  }

  private onItemsChanged(change: SimpleChange) {
    if (!change || !change.currentValue) {
      return;
    }

    this.displayedItems = change.currentValue.map(
      (item) => {
        item.TitleTooltip = this.utilityService.stripTags(item.Title);

        return item;
      },
    );
  }
}
